import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OrgDto} from "../dto/org.dto";
import {Observable, tap} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {UrlBuilder} from "../item/url.item";
import {map} from "rxjs/operators";
import {ContactRelationDto} from "../dto/contact.relation.dto";
import {VoidDto} from "../dto/void.dto";
import {SearchRequest} from "../dto/search/search-table.dto.req";
import {SearchContactRelationRes} from "../dto/search/search-contact-relation.res";
import {isUuid} from "../../libs/utils/epic.utils";

@Injectable({providedIn: 'root'})
export class ContactRelationRepo {

  private readonly crRead = '/v1/org/{orgId}/contact/{contactId}/relation/{id}';
  private readonly crWrite = '/v1/org/{orgId}/contact/{contactId}/relation';
  private readonly crDelete = '/v1/org/{orgId}/contact/{contactId}/relation/{id}/delete';
  private readonly crSearch = '/v1/org/{orgId}/contact/{contactId}/relation/search';

  private readonly http = inject(HttpClient);

  public getById(org: OrgDto, relationId: string, parentContactId: string): Observable<WrapperDto<ContactRelationDto>> {
    const url = UrlBuilder.builder().addPath(this.crRead).addParam('orgId', org.id)
      .addParam('contactId', parentContactId).addParam('id', relationId).build();
    return this.http.get<WrapperDto<ContactRelationDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public update(org: OrgDto, parentContactId: string, relation: ContactRelationDto): Observable<WrapperDto<ContactRelationDto>> {
    const url = UrlBuilder.builder().addPath(this.crWrite).addParam('orgId', org.id)
      .addParam('contactId', parentContactId).build();
    return this.http.post<WrapperDto<ContactRelationDto>>(url.getUrl(), relation, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public delete(org: OrgDto, parentContactId: string, relationId: string): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.crDelete).addParam('orgId', org.id)
      .addParam('contactId', parentContactId).addParam('id', relationId).build();
    return this.http.post<WrapperDto<ContactRelationDto>>(url.getUrl(), {}, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  // ##########################################################################
  // #### Search
  // ##########################################################################

  public search(org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchContactRelationRes>> {
    const contactId = request.filters.find((f) => f.pos === 1001)?.selected?.find((s) => isUuid(s));
    const url = UrlBuilder.builder().addPath(this.crSearch).addParam('orgId', org.id).addParam('contactId', contactId).build();
    return this.http.post<WrapperDto<SearchContactRelationRes>>(url.getUrl(), request, url.getOptions()).pipe(
      tap((res) => res.dataType = res.dataType === 'SearchResultDto' ? 'SearchContactRelationRes' : res.dataType),
      map((res) => new WrapperDto(res))
    );
  }
}
